import { makeObservable, observable } from 'mobx';
import FormModel from '../forms/FormModel';

export class AudioStreamModel extends FormModel {
  constructor() {
    super();
    makeObservable(this);
  }
  @observable
  public id: number;
  @observable
  public audioStream: string;
}
